module.exports = __webpack_public_path__ + "static/media/spider.3b9f3c3d.jpg";